import { render, staticRenderFns } from "./DH17.vue?vue&type=template&id=2528e328&scoped=true"
import script from "./DH17.vue?vue&type=script&lang=js"
export * from "./DH17.vue?vue&type=script&lang=js"
import style0 from "./DH17.vue?vue&type=style&index=0&id=2528e328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528e328",
  null
  
)

export default component.exports